import {Persona} from './persona';

export class Representante extends Persona {
  public id: number;
  public idPersona: number;
  public idFoto: number;
  public idAsamblea: number;
  public descripcion;
  public usuarioRegistro;
}
